module.exports = __webpack_public_path__ + "img/TS.1d9d0722.png";